SAPO.Project.Video._kind    = SV_KIND;
SAPO.Project.Video._version = SV_VERSION;
SAPO.Project.Video._env     = SV_ENV;
